<template>
    <!-- что важно родителям-->
    <div class="block-parents">
        <div class="block-parents__body">
            <BlockParallax class="block-parents__icon block-parents__bottle-pink" speed="10">
                <img src="@/assets/images/icons/bottle-pink.png">
            </BlockParallax>
            <BlockParallax class="block-parents__icon block-parents__bottle-blue block-parents--icon-desktop" speed="5">
                <img src="@/assets/images/icons/bottle-blue.png">
            </BlockParallax>
            <BlockParallax class="block-parents__icon block-parents__toy-blue" speed="10">
                <img src="@/assets/images/icons/toy-blue.png">
            </BlockParallax>
            <BlockParallax class="block-parents__icon block-parents__toy-pink block-parents--icon-desktop" speed="10">
                <img src="@/assets/images/icons/toy-pink.png">
            </BlockParallax>
            <div class="block-parents__content">
                <span class="block-parents__title">Что важно <br> родителям</span>
                <div class="block-parents__box block-parents__box-one">
                    <p class="block-parents__text block-parents__text-one">
                        Вместе с рождением ребенка у родителей появляются совершенно новые потребности. Теперь для нормальной жизни нужны всего лишь просторная прихожая и кухня, кладовая для сезонных вещей и ящиков с игрушками, магазин поблизости и удобный подъезд. Современные застройщики думают о молодых семьях и создают <a href="https://pikabu.ru/story/dofenioy_poche_in_aetdenhitnloolnaes_prl_ph_v_3010839" class="app__link app__link--red" target="_blank">во всех смыслах доступную среду</a>. Вход в подъезд на уровне земли, в подвале кладовки, а лифты и дверные проемы шире стандартных. Главное, ничего не издает страшных звуков.
                    </p>
                    <BlockParallax
                        fixed
                        speed="6"
                        direction="top"
                        transform="translateY"
                        class="block-parents__img-box block-parents__img-box-one"
                    >
                        <img
                            srcset="../assets/4-img.jpg, ../assets/4-img@2x.jpg 2x"
                            src="../assets/4-img.jpg"
                            class="block-parents__img"
                        >
                    </BlockParallax>
                </div>
                <div class="block-parents__box block-parents__box-two">
                    <p class="block-parents__text block-parents__text-two">
                        В первый год младенца нужно регулярно водить на осмотры к врачам, на прививки и Дни здоровья. Каждый такой поход — подвиг для мамы и отгул с работы для папы, потому что поликлиника далеко, в ней очереди и негде оставить коляску при входе. В новостройках как минимум решают одну проблему: поликлиники строят в пешей доступности, а еще там точно можно рассчитывать на современное оборудование.
                        <br><br>
                        В декрете мама (или папа, если в отпуск ушел он) больше всего устает от одинаковых будней. Отдых — это поход в салон красоты возле дома, пока папа катает коляску под окнами. Или свидание с мужем в кофейне поблизости, пока с ребенком гуляют бабушка и дедушка. Идеально, если все это не просто рядом, а на первом этаже дома.
                    </p>
                    <BlockParallax
                        fixed
                        speed="9"
                        direction="top"
                        transform="translateY"
                        class="block-parents__img-box block-parents__img-box-two"
                    >
                        <img
                            srcset="../assets/5-img.jpg, ../assets/5-img@2x.jpg 2x"
                            src="../assets/5-img.jpg"
                            class="block-parents__img"
                        >
                        <div class="image-caption">Детский сад в проекте «Бунинские луга»</div>
                    </BlockParallax>
                </div>
            </div>
        </div>
        <div class="block-parents__mini-block mini-block">
            <div class="mini-block__title">
                <h4>Что нас бесит на&nbsp;детских площадках</h4>
                <a href="https://pikabu.ru/story/_7081484" class="mini-block__button" target="_blank">
                    <span>Читать на&nbsp;Пикабу</span>
                </a>
            </div>
            <div class="mini-block__image">
                <img src="../assets/13-mini.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'
export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-parents {
        margin-top 3rem
        position relative
        +layout-md-and-up() {
            margin-top 6rem
        }
        &__body {
            position relative
            +layout-md-and-up() {
                display flex
            }
        }
        &__box-one {
            margin-top 2.2rem
            +layout-md-and-up() {
                display: flex
            }
            +layout-md-and-up() {
                padding-left: 8rem
            }
        }
        &__box-two {
            +layout-md-and-up() {
                display: flex
                flex-direction row-reverse
                margin-left: -6rem
            }
        }
        &__title {
            padding 0 2rem 0 5rem
            font-size 2.2rem
            line-height 2.6rem
            margin-top 0
            color $color-text
            font-weight $font-semiBold
            display block
            +layout-sm-and-up() {
                text-align: center
                padding: 0
            }
            +layout-md-and-up() {
                font-size 3rem
                margin-top 0.5rem
                line-height 3.5rem
                text-align left
                padding-left: 8rem

            }

        }
        &__text {
            padding 0 2rem 0 5rem
            font-size 1.5rem
            line-height 1.47
            margin 1.6rem 0 0 0
            +layout-md-and-up() {
                max-width 35rem
                padding: 0
            }
        }
        &__text-one {

        }
        &__text-two {
            +layout-md-and-up() {
            max-width 40rem
            }
        }
        &__img-box-one {
            margin-left -1rem
            margin-right -1rem
            margin-top 2rem
            +layout-sm-and-up() {
                max-width 46rem
                margin-left auto
            }
            +layout-md-and-up() {
                margin-top -9rem
                margin-left 5rem
            }
        }
        &__img-box-two {
            padding-left 3rem
            margin-right -1rem
            margin-top 2.5rem
            +layout-sm-and-up() {
                max-width 46rem
                margin-left: auto
                margin-right: auto
                padding-left: 0
            }
            +layout-md-and-up() {
                margin-left 6rem
                margin-top 9rem
            }
        }
        &__img {
            width: 100%
            margin-left auto
            display block
            +layout-sm-and-up() {
                align-self flex-start
                margin-right: 0
            }
        }

        &__icon {
            position absolute
        }
        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__bottle-pink {
            width 100px
            right -35px
            top 0
            transform rotate(-175deg)
            +layout-md-and-up() {
                left -9.7rem
                top 5.8rem
                width 11.8rem
                transform rotate(-1deg)
            }
        }
        &__bottle-blue {
            +layout-md-and-up() {
                width 6.2rem
                right -16.1rem
                top 4.9rem
                transform: rotate(-3.9deg)

            }
        }
        &__toy-blue {
            left -36px
            top 191px
            width 7rem
            transform rotate(69deg)
            +layout-md-and-up() {
                left -21.1rem
                top 18.3rem
                width 11rem
                transform rotate(69deg)
            }
        }
        &__toy-pink {
            +layout-md-and-up() {
                right -8.1rem
                top 14.1rem
                width 11.5rem
            }
        }
    }
    .mini-block {
        clear both
        display block
        width 100%
        max-width 640px
        margin 5rem auto
        display flex
        flex-direction row
        flex-wrap nowrap
        &__title {
            max-width 320px
            h4 {
                padding-bottom 31px
                font-size 24px
                font-weight 600
                letter-spacing 0.26px
                line-height 1.44
                color: #222222
            }
        }
        &__button {
            padding 13px 39px 14px
            font-size 16px
            font-weight 600
            letter-spacing 0.17px
            border-radius 5px
            background-color #8dd2d9
            color #fff
            &:hover {
                background-color #6eccd6
            }
        }
        &__image {
            img {
                width auto
                max-height 215px
            }
        }
        @media screen and (max-width: 700px) {
            max-width 410px
            flex-direction row-reverse
            &__image {
                overflow hidden
                width 8rem
                height 8rem
                border-radius 50%
                margin-right 2rem
                
                img {
                    width auto
                    height 100%
                }
            }
        }
        @media screen and (max-width: 470px) {
            padding 1rem
            &__image {
                display none
            }
        }
    }
</style>
